import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import Button from '@dojo/widgets/button';
import MCQuestionBase from './mc-base';
import css from '../css/definition.m.css';
let Definition = class Definition extends MCQuestionBase {
    _inFlip = false;
    _inDefFinish = false;
    _inDefNext = false;
    onQuestionChange() {
        super.onQuestionChange();
        this._inFlip = false;
        this._inDefFinish = false;
        this._inDefNext = false;
    }
    render_front() {
        const { question } = this.properties;
        const { feedback } = question;
        return v('div', { key: 'card-front', xqa: 'flashcard front', classes: [this.theme(css.front)] }, [
            v('div', { key: 'definition', classes: [this.theme(css.cardDefinition)], innerHTML: feedback })
        ]);
    }
    render_back() {
        const { question: { text, feedback } } = this.properties;
        return v('div', { key: 'card-back', xqa: 'flashcard back', classes: [this.theme(css.back)] }, [
            v('h2', { key: 'term', classes: [this.theme(css.cardTerm)], innerHTML: text }),
            v('div', { key: 'definition', classes: [this.theme(css.cardDefinition)], innerHTML: feedback })
        ]);
    }
    buttons() {
        const { messages } = this.properties.localizedBundle;
        const flipText = messages['flip_card'] || '';
        const finishText = messages['finish'] || '';
        const nextText = messages['next_card'] || '';
        const { question, onNextQuestion, onFinish } = this.properties;
        const { status } = question;
        const islast = question.cursor + 1 === this.get_numberofquestions();
        return v('div', { key: 'card-action', classes: [this.theme(css.oneaction)] }, [
            status === 'question'
                ? w(Button, {
                    onClick: () => {
                        if (!this._inFlip) {
                            this._inFlip = true;
                            question.status = 'feedback';
                            this.update_result();
                            this.invalidate();
                        }
                    }
                }, [flipText])
                : islast
                    ? w(Button, {
                        onClick: () => {
                            if (!this._inDefFinish) {
                                this._inDefFinish = true;
                                this.update_result().then(() => {
                                    onFinish();
                                });
                            }
                        }
                    }, [finishText])
                    : w(Button, {
                        onClick: () => {
                            if (!this._inDefNext) {
                                this._inDefNext = true;
                                this.update_result();
                                onNextQuestion();
                            }
                        }
                    }, [nextText])
        ]);
    }
    render() {
        const { question: { status } } = this.properties;
        const flipped = status !== 'question';
        return v('div', { classes: [this.theme(css.root)] }, [
            this.buttons(),
            v('div', {
                classes: [this.theme(css.flipContainer), flipped ? this.theme(css.flipped) : null],
                ...formatAriaProperties({ live: 'assertive' })
            }, [v('div', { classes: [this.theme(css.flipper)] }, [flipped ? this.render_back() : this.render_front()])])
        ]);
    }
};
Definition = __decorate([
    theme(css)
], Definition);
export { Definition };
